export const rejectedListHeaders = [
  { header: 'referenceNumber', label: 'reference' },
  { header: 'partnerID', label: 'partner' },
  { header: 'agencyID', label: 'agency' },
  { header: 'firstReceivedOn', label: 'first received on' },
  { header: 'lastReceivedOn', label: 'last received on' },
  { header: 'count', label: 'count' },
  { header: 'errorMessage', label: 'errors' },
  { header: 'rejectedID', label: 'rejected id', hidden: true },
];

export const rejectedFlyout = 'rejected';

export const rowsPerPageOptions = [
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];
